import { call, put, takeLatest, takeEvery } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../../services/apis";

export function* handleFetchLabs({ payload }) {
  try {
    const res = yield call(API.fetchAllLabs, payload);
    const { data } = res;
    yield put(actions.fetchLabsSuccess(data));
  } catch (err) {
    yield put(actions.fetchLabsFailure(err?.response?.data));
  }
}

export function* handleDownload({ payload }) {
  try {
    const { fileName } = payload.data;
    //const res = yield call(API.getDownloadUrl, payload);
    const res = yield call(API.getFileUrl, {
      blobName: fileName,
      source: {
        name: process.env.REACT_APP_ENVIRONMENT,
      },
    });
    const { data } = res;
    const file = yield call(API.downloadFile, {
      url: data.data.document,
      data: "",
    });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(file.data);
    link.setAttribute(
      "download",
      fileName.split("_")[fileName.split("_").length - 1]
    );
    link.setAttribute("target", "_blank");
    document.body.appendChild(link);
    link.dispatchEvent(
      new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window,
      })
    );
    document.body.removeChild(link);
    yield put(actions.downloadDocumentSuccess({ id: payload.id }));
  } catch (err) {
    yield put(actions.downloadDocumentFailure({ id: payload.id, err }));
  }
}

export function* handleAddOrEditLabOperator({ payload }) {
  try {
    const res = yield call(API.addOrUpdateLabOperator, payload);
    const { data } = res;
    payload.onSuccess();
    yield put(actions.addOrEditLabOperatorSuccess(data));
  } catch (err) {
    yield put(actions.addOrEditLabOperatorFailure(err?.response?.data));
    payload.onFailure(err?.response?.data);
    console.error("Error in adding or editing lab operator:", err);
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* labListingSaga() {
  yield takeLatest(actions.fetchLabs.type, handleFetchLabs);
  yield takeEvery(actions.downloadDocument.type, handleDownload);
  yield takeEvery(actions.addOrEditLabOperator.type, handleAddOrEditLabOperator);
}
